exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.main {\n  border: 2px solid silver;\n  border-radius: 12px;\n  margin: 1ex;\n  padding: 1ex;\n}\n\ndiv.cite {\n  margin:1ex;\n  padding:1ex;\n  border: 2px solid black\n}\n\ndiv.topLineLeft {\n  font-size: small;\n  text-align: left;\n}\n\n\ndiv.topLineRight {\n  float: right;\n  font-size: small;\n  text-align: right;\n}\n\ndiv.topLineRight> span {\n  display: inline-block;\n  padding: 2px;\n  border: thin solid silver;\n  margin: 0 3px;\n}\n\n:host>>> span.year {\n  font-weight: bold;\n}\n\n:host>>> span.highlight {\n  background-color: #F5F583;\n}\n\n:host>>> span.searchHit {\n  background-color: lightsteelblue;\n}\n\n:host>>> span.criterionHit {\n  background-color: #BCEDAF;\n  ;\n}\n\n:host >>> div.pnDiv {\n  margin-bottom:1ex;\n}\n\n:host >>> div.pnDiv a {\n  font-size: small;\n}\n\ndiv.searchDetails {\n  border: thick double silver;\n  margin: 1ex;\n  padding: 1ex;\n}\n\nspan.jump {\n  cursor: pointer;\n  font-size: 80%;\n  background: silver;\n  padding: 3px 8px;\n  border-radius: 4px;\n}\n\nspan.jump:hover {\n  text-decoration: underline;\n}\n\nspan.order {\n  margin-right:1em;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/db-record-box/db-record-box.component.css
// module id = 385
// module chunks = 0